import { Card, styled } from "@mui/material";
import { getColor } from "../color/color";

export const StyledCardCurrentPortfolio = styled(Card)(({ theme }) => ({
  marginBottom: "30px",
  background: "white",
  borderRadius: "12px",
  border: "0.60px #A8ABB1 solid",
  position: "relative",
  padding: "12px",
  paddingTop: "20px",
  paddingBottom: "20px",
  display: "flex",
  justifyContent: "space-between",
}));
export const ACRStyledButtonCurrentPortfolio = {
  width: "100%",
  maxWidth: "350px",
  backgroundColor: getColor.ColorButtonPrimarysurface,
  color: getColor.PrimaryWhite,
  borderRadius: "40px",
  p: "20px",

  fontWeight: 700,
  fontSize: "16px",
  textAlign: "center",
  textTransform: "initial",
};
